module.exports = __webpack_public_path__ + "static/img/bg.cc040ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/bg.png
// module id = /B4r
// module chunks = 0